<template>
  <DocumentWorkspaceDialog ref="dialog" />
</template>

<script>
  import DocumentWorkspaceDialog from './DocumentWorkspaceDialog.vue';
  import { EventBus, DOCUMENT_EVENTS } from '@/event-bus';
  import { registerWorkspaceHost, unregisterWorkspaceHost } from '../utils/workspaceHost';

  const REFRESH_DEBOUNCE_MS = 300;

  /**
   * App-wide Document Workspace for places that cannot mount their own, such as attachment cards.
   *  - `EventBus.$emit(DOCUMENT_EVENTS.OPEN_WORKSPACE, { documentId, document?, revisionId?, tab? })`
   *    (or `openDocumentWorkspace(payload)` from `utils/workspaceHost`, which says whether a host heard it)
   *  - `EventBus.$emit(DOCUMENT_EVENTS.OPEN_VERSIONS, { documentId })` opens it on the Versions tab
   * It also refreshes the facility's document list whenever a document's current version changes.
   *
   * MainView mounts one. Pages with their own layout (registers, tags) mount their own, because the
   * events go nowhere without a host.
   */
  export default {
    name: 'DocumentWorkspaceHost',
    components: { DocumentWorkspaceDialog },
    created() {
      registerWorkspaceHost();
      EventBus.$on(DOCUMENT_EVENTS.OPEN_WORKSPACE, this.open);
      EventBus.$on(DOCUMENT_EVENTS.OPEN_VERSIONS, this.openVersions);
      EventBus.$on(DOCUMENT_EVENTS.DOCUMENT_CHANGED, this.refreshDocuments);
    },
    beforeDestroy() {
      unregisterWorkspaceHost();
      EventBus.$off(DOCUMENT_EVENTS.OPEN_WORKSPACE, this.open);
      EventBus.$off(DOCUMENT_EVENTS.OPEN_VERSIONS, this.openVersions);
      EventBus.$off(DOCUMENT_EVENTS.DOCUMENT_CHANGED, this.refreshDocuments);
      clearTimeout(this.refreshTimer);
    },
    methods: {
      open(payload = {}) {
        this.$refs.dialog?.open(payload);
      },
      openVersions(payload = {}) {
        this.$refs.dialog?.open({ documentId: payload.documentId, tab: 'versions' });
      },
      // A pin, revert, new version or edit changes a listed document. Debounced because a batch
      // upload emits one event per file and the list reload fetches every document.
      refreshDocuments() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => {
          this.refreshTimer = null;
          if (!this.$store.state.assetId) return;
          this.$store.dispatch('FETCH_ALL_DOCUMENTS');
        }, REFRESH_DEBOUNCE_MS);
      },
    },
  };
</script>
